"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5706],{

/***/ 18414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CancelStrategyModal; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/chunk-6RSEZNRH.mjs
var chunk_6RSEZNRH = __webpack_require__(7963);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-MSA2NPQT.mjs + 2 modules
var chunk_MSA2NPQT = __webpack_require__(35541);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-JQMJHPZH.mjs
var chunk_JQMJHPZH = __webpack_require__(83589);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-EL2VKIZQ.mjs + 3 modules
var chunk_EL2VKIZQ = __webpack_require__(14581);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-5FG5SY5K.mjs
var chunk_5FG5SY5K = __webpack_require__(64859);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-OFOVX77R.mjs
var chunk_OFOVX77R = __webpack_require__(54346);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-ZHMYA64R.mjs + 2 modules
var chunk_ZHMYA64R = __webpack_require__(55281);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-2OOHT3W5.mjs
var chunk_2OOHT3W5 = __webpack_require__(71293);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-KRPLQIP4.mjs
var chunk_KRPLQIP4 = __webpack_require__(93717);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-7OLJDQMT.mjs
var chunk_7OLJDQMT = __webpack_require__(22757);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-BL2ZZSHG.mjs
var chunk_BL2ZZSHG = __webpack_require__(65028);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-PULVB27S.mjs
var chunk_PULVB27S = __webpack_require__(57747);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-FAWTVNS3.mjs
var chunk_FAWTVNS3 = __webpack_require__(27239);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/chunk-5PH6ULNP.mjs
var chunk_5PH6ULNP = __webpack_require__(81136);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-3ASUQ6PA.mjs
var chunk_3ASUQ6PA = __webpack_require__(34292);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/chunk-QINAG4RG.mjs + 2 modules
var chunk_QINAG4RG = __webpack_require__(6089);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-RAWN7VJ3.mjs
var chunk_RAWN7VJ3 = __webpack_require__(14253);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chunk-UVUR7MCU.mjs + 3 modules
var chunk_UVUR7MCU = __webpack_require__(93108);
// EXTERNAL MODULE: ./src/helpers/strategy/dcaPlus/index.tsx
var dcaPlus = __webpack_require__(23175);
// EXTERNAL MODULE: ./src/utils/getDenomInfo.tsx
var getDenomInfo = __webpack_require__(11599);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./src/hooks/useWallet.ts
var useWallet = __webpack_require__(5403);
// EXTERNAL MODULE: ./node_modules/cosmjs-types/cosmwasm/wasm/v1/tx.js
var tx = __webpack_require__(2387);
;// CONCATENATED MODULE: ./src/helpers/encode.tsx
function encode(msg) {
  var raw = JSON.stringify(msg);
  var textEncoder = new TextEncoder();
  return textEncoder.encode(raw);
}
// EXTERNAL MODULE: ./src/helpers/chains/index.ts
var chains = __webpack_require__(87038);
// EXTERNAL MODULE: ./src/hooks/useChainId.ts
var useChainId = __webpack_require__(12680);
;// CONCATENATED MODULE: ./src/hooks/useCancelStrategy.ts








function getCancelVaultExecuteMsg(strategyId, senderAddress, contractAddress) {
  var msg = {
    cancel_vault: {
      vault_id: strategyId
    }
  };
  var encoded_msg = encode(msg);
  var msgExecuteContract = tx.MsgExecuteContract.fromPartial({
    contract: contractAddress,
    msg: encoded_msg,
    sender: senderAddress
  });
  var protobufMsg = {
    typeUrl: '/cosmwasm.wasm.v1.MsgExecuteContract',
    value: msgExecuteContract
  };
  return protobufMsg;
}

var useCancelStrategy = function useCancelStrategy() {
  var _useWallet = (0,useWallet/* useWallet */.O)(),
      address = _useWallet.address,
      getSigningClient = _useWallet.getSigningClient,
      connected = _useWallet.connected;

  var _useChainId = (0,useChainId/* useChainId */.x)(),
      chainId = _useChainId.chainId;

  var _useQuery = (0,useQuery/* useQuery */.a)(['signingCosmWasmClient', chainId], getSigningClient, {
    enabled: !!chainId && connected,
    staleTime: 1000 * 60 * 10
  }),
      client = _useQuery.data;

  return (0,useMutation/* useMutation */.D)(function (strategy) {
    if (client == null) {
      throw new Error('no client');
    }

    if (address == null) {
      throw new Error('no address');
    }

    if (chainId == null) {
      throw new Error('no chain');
    }

    if (address !== strategy.owner) {
      throw new Error('You are not the owner of this strategy');
    }

    return client.signAndBroadcast(address, [getCancelVaultExecuteMsg(strategy.id, address, (0,chains/* getDCAContractAddress */.cr)(chainId))], 'auto');
  }, {
    onError: function onError(error, strategy) {
      esm_exports/* captureException */.Tb(error, {
        tags: {
          chain: chainId,
          strategy: JSON.stringify(strategy)
        }
      });
    }
  });
};

/* harmony default export */ var hooks_useCancelStrategy = (useCancelStrategy);
// EXTERNAL MODULE: ./src/helpers/format/formatDate.tsx
var formatDate = __webpack_require__(34886);
// EXTERNAL MODULE: ./src/hooks/useStrategyEvents.ts
var useStrategyEvents = __webpack_require__(64735);
// EXTERNAL MODULE: ./src/helpers/strategy/isDcaPlus/index.ts
var isDcaPlus = __webpack_require__(67207);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CancelStrategyModal.tsx









function CancelStrategyModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onCancel = _ref.onCancel,
      strategy = _ref.strategy;

  var _useCancelStrategy = hooks_useCancelStrategy(),
      cancelStrategy = _useCancelStrategy.mutate,
      isLoading = _useCancelStrategy.isLoading;

  var toast = (0,chunk_6RSEZNRH/* useToast */.p)();

  var _useStrategyEvents = (0,useStrategyEvents/* default */.Z)(strategy.id, isOpen),
      events = _useStrategyEvents.data,
      isEventsLoading = _useStrategyEvents.isLoading;

  var handleCancelStrategy = function handleCancelStrategy() {
    return cancelStrategy(strategy, {
      onSuccess: function onSuccess() {
        toast({
          title: 'Strategy cancelled.',
          position: 'top-right',
          description: "We've cancelled your strategy and refunded remaining funds.",
          status: 'success',
          duration: 12000,
          variant: 'subtle',
          isClosable: true
        });
        onCancel();
      },
      onError: function onError(error) {
        toast({
          title: 'Something went wrong',
          position: 'top-right',
          description: "There was a problem cancelling your strategy (Reason: ".concat(error.message, ")"),
          status: 'error',
          duration: 12000,
          isClosable: true,
          variant: 'subtle'
        });
      },
      onSettled: onClose
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_MSA2NPQT/* Modal */.u_, {
    isOpen: isOpen,
    onClose: onClose,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_JQMJHPZH/* ModalOverlay */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_EL2VKIZQ/* ModalContent */.h, {
      "data-testid": "cancel-strategy-modal",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_5FG5SY5K/* ModalHeader */.x, {
        textAlign: "center",
        children: "Cancel Strategy?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_OFOVX77R/* ModalBody */.f, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
          spacing: 4,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
            textStyle: "body-xs",
            textAlign: "center",
            children: "By cancelling this strategy the unswapped balance in the vault will be returned. Once cancelled, this strategy can not be started again."
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
            layerStyle: "panel",
            p: 4,
            mt: 4,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
              align: "center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_7OLJDQMT/* Heading */.X, {
                size: "sm",
                children: "Amount to be returned:"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_BL2ZZSHG/* Spacer */.L, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_2OOHT3W5/* Text */.x, {
                as: "span",
                fontSize: "lg",
                color: "blue.200",
                children: [(0,getDenomInfo/* fromAtomic */.b1)(strategy.initialDenom, Number(strategy.rawData.balance.amount)), ' ', strategy.initialDenom.name]
              })]
            }), (0,isDcaPlus/* isDcaPlus */.o)(strategy) && /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
              align: "center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_7OLJDQMT/* Heading */.X, {
                size: "sm",
                children: "Amount escrowed:"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_BL2ZZSHG/* Spacer */.L, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_2OOHT3W5/* Text */.x, {
                as: "span",
                fontSize: "lg",
                color: "blue.200",
                children: [(0,dcaPlus/* getEscrowAmount */.TK)(strategy), " ", strategy.resultingDenom.name]
              })]
            })]
          }), (0,isDcaPlus/* isDcaPlus */.o)(strategy) && /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_PULVB27S/* Box */.xu, {
            fontSize: "xs",
            bg: "abyss.200",
            p: 4,
            borderRadius: "md",
            children: isEventsLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_FAWTVNS3/* Center */.M, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_5PH6ULNP/* Spinner */.$, {})
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_3ASUQ6PA/* HStack */.U, {
              spacing: 3,
              color: "brand.200",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_QINAG4RG/* Image */.E, {
                src: "/images/lightBulbOutline.svg",
                alt: "light bulb"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_2OOHT3W5/* Text */.x, {
                children: ["Your escrow (minus performance fee) is estimated to be returned on", ' ', (0,formatDate/* formatDate */.p)((0,dcaPlus/* getStandardDcaEndDate */.gy)(strategy, events))]
              })]
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_RAWN7VJ3/* ModalFooter */.m, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_KRPLQIP4/* Flex */.k, {
          justify: "center",
          w: "full",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
            direction: "column",
            spacing: 3,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_UVUR7MCU/* Button */.z, {
              onClick: handleCancelStrategy,
              isLoading: isLoading,
              "data-testid": "cancel-strategy-modal-cancel-button",
              children: "Cancel Strategy"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_UVUR7MCU/* Button */.z, {
              variant: "ghost",
              onClick: onClose,
              "data-testid": "cancel-strategy-modal-close-button",
              children: "Back"
            })]
          })
        })
      })]
    })]
  });
}

/***/ }),

/***/ 90365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ StrategyStatusBadge; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97702);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24880);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


function StrategyStatusBadge(_ref) {
  var strategy = _ref.strategy;
  var status = strategy.status;
  var statusColorSchemes = {
    active: 'green',
    scheduled: 'yellow',
    completed: 'blue',
    cancelled: 'grey'
  };
  var statusTooltips = {
    active: 'Your strategy has started',
    scheduled: 'Your strategy is scheduled to start',
    completed: 'Your strategy has completed',
    cancelled: 'Your strategy has been cancelled'
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
    label: statusTooltips[status],
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Badge */ .C, {
      cursor: "default",
      colorScheme: statusColorSchemes[status] || 'grey',
      textTransform: "capitalize",
      children: status
    })
  });
}

/***/ }),

/***/ 13435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ generateStrategyTopUpUrl; }
/* harmony export */ });
function generateStrategyTopUpUrl(id, chainId) {
  return {
    pathname: '/strategies/top-up/',
    query: {
      id: id,
      chain: chainId
    }
  };
}

/***/ }),

/***/ 65442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ getModel; },
  "i": function() { return /* binding */ getModelFromId; }
});

;// CONCATENATED MODULE: ./src/helpers/ml/getModel/predictionData.ts
var predictionData = {
  Predict30: {
    truePositiveRate: 0.68,
    falseNegativeRate: 0.31,
    probabilityOfOutPerformance: 0.85
  },
  Predict35: {
    truePositiveRate: 0.67,
    falseNegativeRate: 0.31,
    probabilityOfOutPerformance: 0.88
  },
  Predict40: {
    truePositiveRate: 0.66,
    falseNegativeRate: 0.3,
    probabilityOfOutPerformance: 0.89
  },
  Predict45: {
    truePositiveRate: 0.67,
    falseNegativeRate: 0.3,
    probabilityOfOutPerformance: 0.92
  },
  Predict50: {
    truePositiveRate: 0.68,
    falseNegativeRate: 0.3,
    probabilityOfOutPerformance: 0.94
  },
  Predict55: {
    truePositiveRate: 0.69,
    falseNegativeRate: 0.28,
    probabilityOfOutPerformance: 0.95
  },
  Predict60: {
    truePositiveRate: 0.69,
    falseNegativeRate: 0.27,
    probabilityOfOutPerformance: 0.96
  },
  Predict70: {
    truePositiveRate: 0.71,
    falseNegativeRate: 0.25,
    probabilityOfOutPerformance: 0.96
  },
  Predict80: {
    truePositiveRate: 0.74,
    falseNegativeRate: 0.21,
    probabilityOfOutPerformance: 0.96
  },
  Predict90: {
    truePositiveRate: 0.75,
    falseNegativeRate: 0.18,
    probabilityOfOutPerformance: 0.97
  }
};
;// CONCATENATED MODULE: ./src/helpers/ml/getModel/index.ts

function getModel(duration) {
  if (duration >= 30 && duration <= 32) {
    return predictionData.Predict30;
  }

  if (duration >= 33 && duration <= 38) {
    return predictionData.Predict35;
  }

  if (duration >= 39 && duration <= 44) {
    return predictionData.Predict40;
  }

  if (duration >= 45 && duration <= 51) {
    return predictionData.Predict45;
  }

  if (duration >= 52 && duration <= 57) {
    return predictionData.Predict50;
  }

  if (duration >= 58 && duration <= 65) {
    return predictionData.Predict55;
  }

  if (duration >= 66 && duration <= 77) {
    return predictionData.Predict60;
  }

  if (duration >= 78 && duration <= 96) {
    return predictionData.Predict70;
  }

  if (duration > 97 && duration <= 123) {
    return predictionData.Predict80;
  }

  if (duration >= 124) {
    return predictionData.Predict90;
  }

  return null;
}
function getModelFromId(id) {
  switch (id) {
    case 30:
      return predictionData.Predict30;

    case 35:
      return predictionData.Predict35;

    case 40:
      return predictionData.Predict40;

    case 45:
      return predictionData.Predict45;

    case 50:
      return predictionData.Predict50;

    case 55:
      return predictionData.Predict55;

    case 60:
      return predictionData.Predict60;

    case 70:
      return predictionData.Predict70;

    case 80:
      return predictionData.Predict80;

    case 90:
      return predictionData.Predict90;

    default:
      return null;
  }
}

/***/ }),

/***/ 36369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getSwapRange; },
/* harmony export */   "h": function() { return /* binding */ getSwapRangeFromModel; }
/* harmony export */ });
/* harmony import */ var _getModel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65442);

var PREDICT_10_TRUE_POSITIVE_RATE = 0.7;
var PREDICT_10_FALSE_NEGATIVE_RATE = 0.31;
function getSwapRangeFromModel(swapAmount, model, miniumSwapAmount) {
  if (model) {
    var truePositiveRate = model.truePositiveRate,
        falseNegativeRate = model.falseNegativeRate;
    var minNoise = 0.45 * swapAmount / PREDICT_10_TRUE_POSITIVE_RATE - swapAmount;
    var maxNoise = 0.45 * swapAmount / PREDICT_10_FALSE_NEGATIVE_RATE - swapAmount;
    var minBase = 0.45 * swapAmount / truePositiveRate;
    var maxBase = 0.45 * swapAmount / falseNegativeRate;
    var min = minBase + 0.05 * minNoise;
    var max = maxBase + 0.05 * maxNoise;
    return {
      min: Math.max(miniumSwapAmount, Number(min.toFixed(3))),
      max: Number(max.toFixed(3))
    };
  }

  return null;
}
function getSwapRange(swapAmount, duration, minimumSwapAmount) {
  var model = (0,_getModel__WEBPACK_IMPORTED_MODULE_0__/* .getModel */ .P)(duration);
  return getSwapRangeFromModel(swapAmount, model, minimumSwapAmount);
}

/***/ }),

/***/ 23175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AG": function() { return /* binding */ getRemainingExecutionsRange; },
/* harmony export */   "E": function() { return /* binding */ getAccumulationGained; },
/* harmony export */   "Ie": function() { return /* binding */ getPerformanceFactor; },
/* harmony export */   "Mk": function() { return /* binding */ getStandardDcaTotalSwapped; },
/* harmony export */   "Q4": function() { return /* binding */ isEscrowPending; },
/* harmony export */   "TK": function() { return /* binding */ getEscrowAmount; },
/* harmony export */   "eh": function() { return /* binding */ getSwappedSaved; },
/* harmony export */   "f": function() { return /* binding */ getStrategySwapRange; },
/* harmony export */   "gy": function() { return /* binding */ getStandardDcaEndDate; },
/* harmony export */   "i7": function() { return /* binding */ getStandardDcaRemainingBalance; },
/* harmony export */   "mX": function() { return /* binding */ getNumberOfPastSwaps; },
/* harmony export */   "oJ": function() { return /* binding */ getStandardDcaAveragePurchasePrice; },
/* harmony export */   "qG": function() { return /* binding */ getStrategyEndDateRange; },
/* harmony export */   "sm": function() { return /* binding */ getStandardDcaTotalReceived; },
/* harmony export */   "u$": function() { return /* binding */ getStandardDcaAverageSellPrice; }
/* harmony export */ });
/* unused harmony exports getStandardDcaTotalCost, getStandardDcaTotalDeposit, getStandardDcaTotalReceivedBeforeFees, getEscrowLevel, getStrategyModel, getReturnedEscrowAmount, getStandardDcaRemainingExecutions, getLastExecutionDateFromStrategyEvents */
/* harmony import */ var _utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11599);
/* harmony import */ var _utils_totalExecutions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66260);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18459);
/* harmony import */ var _helpers_ml_getModel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65442);
/* harmony import */ var _helpers_ml_getSwapRange__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36369);
/* harmony import */ var _helpers_strategy__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6686);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _helpers_getEndDateFromRemainingExecutions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22349);
/* harmony import */ var _isDcaPlus__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67207);
/* harmony import */ var _isWeightedScale__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19766);










function getStandardDcaTotalReceived(strategy) {
  var _ref = (0,_isDcaPlus__WEBPACK_IMPORTED_MODULE_6__/* .getDcaPlusConfig */ .u)(strategy) || {},
      standard_dca_received_amount = _ref.standard_dca_received_amount;

  return Number((0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_0__/* .fromAtomic */ .b1)(strategy.resultingDenom, Number(standard_dca_received_amount === null || standard_dca_received_amount === void 0 ? void 0 : standard_dca_received_amount.amount)).toFixed(strategy.resultingDenom.significantFigures));
}
function getStandardDcaTotalSwapped(strategy) {
  var _ref2 = (0,_isDcaPlus__WEBPACK_IMPORTED_MODULE_6__/* .getDcaPlusConfig */ .u)(strategy) || {},
      standard_dca_swapped_amount = _ref2.standard_dca_swapped_amount;

  return Number((0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_0__/* .fromAtomic */ .b1)(strategy.initialDenom, Number(standard_dca_swapped_amount === null || standard_dca_swapped_amount === void 0 ? void 0 : standard_dca_swapped_amount.amount)).toFixed(strategy.initialDenom.significantFigures));
}
function getStandardDcaTotalCost(strategy, dexFee) {
  return Number((getStandardDcaTotalSwapped(strategy) * (1 - dexFee - SWAP_FEE)).toFixed(6));
}
function getStandardDcaTotalDeposit(strategy) {
  var _ref3 = (0,_isDcaPlus__WEBPACK_IMPORTED_MODULE_6__/* .getDcaPlusConfig */ .u)(strategy) || {},
      total_deposit = _ref3.total_deposit;

  return Number((0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_0__/* .fromAtomic */ .b1)(strategy.initialDenom, Number(total_deposit === null || total_deposit === void 0 ? void 0 : total_deposit.amount)).toFixed(strategy.initialDenom.significantFigures));
}
function getStandardDcaTotalReceivedBeforeFees(strategy, dexFee) {
  var feeFactor = src_constants__WEBPACK_IMPORTED_MODULE_1__/* .SWAP_FEE */ .OJ + dexFee;
  return getStandardDcaTotalReceived(strategy) / (1 - feeFactor);
}
function getStandardDcaAveragePurchasePrice(strategy, dexFee) {
  return getStandardDcaTotalSwapped(strategy) / getStandardDcaTotalReceivedBeforeFees(strategy, dexFee);
}
function getStandardDcaAverageSellPrice(strategy, dexFee) {
  return getStandardDcaTotalReceivedBeforeFees(strategy, dexFee) / getStandardDcaTotalSwapped(strategy);
}
function getEscrowLevel(strategy) {
  var _ref4 = getDcaPlusConfig(strategy) || {},
      escrow_level = _ref4.escrow_level;

  return Number(escrow_level);
}
function getEscrowAmount(strategy) {
  var _ref5 = (0,_isDcaPlus__WEBPACK_IMPORTED_MODULE_6__/* .getDcaPlusConfig */ .u)(strategy) || {},
      escrowed_balance = _ref5.escrowed_balance;

  return Number((0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_0__/* .fromAtomic */ .b1)(strategy.resultingDenom, Number(escrowed_balance === null || escrowed_balance === void 0 ? void 0 : escrowed_balance.amount)).toFixed(strategy.resultingDenom.significantFigures));
}
function getAccumulationGained(strategy) {
  var standardDcaTotalReceived = getStandardDcaTotalReceived(strategy);
  var totalReceived = (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .getTotalReceived */ .ZD)(strategy);
  var difference = totalReceived - standardDcaTotalReceived;
  return Number(difference.toFixed(6));
}
function getSwappedSaved(strategy) {
  var standardDcaTotalSwapped = getStandardDcaTotalSwapped(strategy);
  var totalSwapped = (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .getTotalSwapped */ .cc)(strategy);
  var difference = standardDcaTotalSwapped - totalSwapped;
  return Number(difference.toFixed(6));
}
function getNumberOfPastSwaps(strategy) {
  var totalSwapped = getStandardDcaTotalSwapped(strategy);
  var swapAmount = (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .getSwapAmount */ .Pg)(strategy);
  return Math.floor(totalSwapped / (0,_utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_0__/* .fromAtomic */ .b1)(strategy.initialDenom, swapAmount));
}
function getStrategyModel(strategy) {
  var _ref6 = (0,_isDcaPlus__WEBPACK_IMPORTED_MODULE_6__/* .getDcaPlusConfig */ .u)(strategy) || {},
      model_id = _ref6.model_id;

  return (0,_helpers_ml_getModel__WEBPACK_IMPORTED_MODULE_2__/* .getModelFromId */ .i)(model_id);
}
function getStrategySwapRange(strategy) {
  if ((0,_isDcaPlus__WEBPACK_IMPORTED_MODULE_6__/* .isDcaPlus */ .o)(strategy)) {
    var swapAmount = (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .getSwapAmount */ .Pg)(strategy);
    var model = getStrategyModel(strategy);

    var _getStrategyInitialDe = (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .getStrategyInitialDenom */ .vB)(strategy),
        minimumSwapAmount = _getStrategyInitialDe.minimumSwapAmount;

    return (0,_helpers_ml_getSwapRange__WEBPACK_IMPORTED_MODULE_3__/* .getSwapRangeFromModel */ .h)(swapAmount, model, minimumSwapAmount);
  }

  if ((0,_isWeightedScale__WEBPACK_IMPORTED_MODULE_7__/* .isWeightedScale */ .U)(strategy)) {
    var _ref7 = (0,_isWeightedScale__WEBPACK_IMPORTED_MODULE_7__/* .getWeightedScaleConfig */ .$)(strategy) || {},
        multiplier = _ref7.multiplier,
        increase_only = _ref7.increase_only;

    var _swapAmount = (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .getSwapAmount */ .Pg)(strategy);

    if ((0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .isBuyStrategy */ .sh)(strategy)) {
      var _max = Number((_swapAmount * (1 - 0.5 * Number(multiplier))).toFixed(6));

      var _min = Number((_swapAmount * (1 + 0.5 * Number(multiplier))).toFixed(6));

      var _checkMin = _min < 0 ? 0 : _min;

      var _checkMax = _max < 0 ? 0 : _max;

      return {
        min: (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .isBuyStrategy */ .sh)(strategy) && !increase_only ? _checkMin : _swapAmount,
        max: !(0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .isBuyStrategy */ .sh)(strategy) && !increase_only ? _checkMax : _swapAmount
      };
    }

    var min = Number((_swapAmount * (1 - 0.5 * Number(multiplier))).toFixed(6));
    var max = Number((_swapAmount * (1 + 0.5 * Number(multiplier))).toFixed(6));
    var checkMin = min < 0 ? 0 : min;
    var checkMax = max < 0 ? 0 : max;
    return {
      min: (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .isBuyStrategy */ .sh)(strategy) && !increase_only ? checkMin : _swapAmount,
      max: !(0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .isBuyStrategy */ .sh)(strategy) && !increase_only ? checkMax : _swapAmount
    };
  }

  return undefined;
}
function getPerformanceFactor(performance) {
  var factor = Number((performance === null || performance === void 0 ? void 0 : performance.factor) || 0);
  var rounded = Number(factor.toFixed(4));
  var difference = rounded - 1;
  return difference;
}

function getDcaPlusFee(strategy, performance) {
  var _ref8 = performance || {},
      fee = _ref8.fee;

  return Number(fromAtomic(strategy.resultingDenom, Number(fee === null || fee === void 0 ? void 0 : fee.amount)).toFixed(strategy.resultingDenom.significantFigures));
}

function getReturnedEscrowAmount(strategy, performance) {
  return getEscrowAmount(strategy) - getDcaPlusFee(strategy, performance);
}
function getStandardDcaRemainingBalance(strategy) {
  return getStandardDcaTotalDeposit(strategy) - getStandardDcaTotalSwapped(strategy);
}
function getRemainingExecutionsRange(strategy) {
  var balance = (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .getStrategyBalance */ .uo)(strategy);

  var _ref9 = getStrategySwapRange(strategy) || {},
      minSwap = _ref9.min,
      maxSwap = _ref9.max;

  if ((0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .isBuyStrategy */ .sh)(strategy) && (0,_isWeightedScale__WEBPACK_IMPORTED_MODULE_7__/* .isWeightedScale */ .U)(strategy)) {
    return {
      min: minSwap && (0,_utils_totalExecutions__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(balance, minSwap),
      max: maxSwap && (0,_utils_totalExecutions__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(balance, maxSwap)
    };
  }

  return {
    min: maxSwap && (0,_utils_totalExecutions__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(balance, maxSwap),
    max: minSwap && (0,_utils_totalExecutions__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(balance, minSwap)
  };
}
function getStandardDcaRemainingExecutions(strategy) {
  var balance = getStandardDcaRemainingBalance(strategy);
  var swapAmount = (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .getSwapAmount */ .Pg)(strategy);
  return (0,_utils_totalExecutions__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(balance, swapAmount);
}
function isEscrowPending(strategy) {
  return (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .getStrategyBalance */ .uo)(strategy) === 0 && getEscrowAmount(strategy) > 0;
}
function getLastExecutionDateFromStrategyEvents(events) {
  var lastExecutionEvent = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.findLast)(events, function (event) {
    var data = event.data;

    if ('simulated_dca_vault_execution_completed' in data) {
      return data.simulated_dca_vault_execution_completed;
    }

    return false;
  }); // vault has no executions yet

  if (!lastExecutionEvent) {
    return undefined;
  }

  return new Date(Number(lastExecutionEvent.timestamp) / 1000000);
}
function getStandardDcaEndDate(strategy, strategyEvents) {
  var remainingExecutions = getStandardDcaRemainingExecutions(strategy);
  var lastExecutionEvent = getLastExecutionDateFromStrategyEvents(strategyEvents);

  if (!lastExecutionEvent) {
    return undefined;
  }

  return (0,_helpers_getEndDateFromRemainingExecutions__WEBPACK_IMPORTED_MODULE_9__/* .getEndDateFromRemainingExecutions */ .G)(strategy, lastExecutionEvent, remainingExecutions);
}
function getStrategyEndDateRange(strategy, strategyEvents) {
  var _ref10 = getRemainingExecutionsRange(strategy) || {},
      min = _ref10.min,
      max = _ref10.max;

  return {
    min: !(0,lodash__WEBPACK_IMPORTED_MODULE_5__.isNil)(min) && (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .getStrategyEndDateFromRemainingExecutions */ .FN)(strategy, strategyEvents, min),
    max: !(0,lodash__WEBPACK_IMPORTED_MODULE_5__.isNil)(max) && (0,_helpers_strategy__WEBPACK_IMPORTED_MODULE_4__/* .getStrategyEndDateFromRemainingExecutions */ .FN)(strategy, strategyEvents, max)
  };
}

/***/ }),

/***/ 12229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ useCalcClient; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/hooks/useCosmWasmClient.ts
var useCosmWasmClient = __webpack_require__(32178);
// EXTERNAL MODULE: ./src/hooks/useChainId.ts
var useChainId = __webpack_require__(12680);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./src/hooks/useDenoms.ts
var useDenoms = __webpack_require__(99867);
// EXTERNAL MODULE: ./src/helpers/chains/index.ts
var chains = __webpack_require__(87038);
// EXTERNAL MODULE: ./src/hooks/useCalcClient/getClient/clients/cosmos/index.ts + 1 modules
var cosmos = __webpack_require__(22606);
;// CONCATENATED MODULE: ./src/hooks/useCalcClient/getClient/index.ts


function getClient(chainId, cosmWasmClient, getDenomById) {
  if (!cosmWasmClient) return null;
  return (0,cosmos/* default */.Z)(chainId, (0,chains/* getDCAContractAddress */.cr)(chainId), cosmWasmClient, getDenomById);
}
;// CONCATENATED MODULE: ./src/hooks/useCalcClient/index.ts


var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






function useCalcClient(injectedChainId) {
  var _useChainId = (0,useChainId/* useChainId */.x)(),
      currentChainId = _useChainId.chainId;

  var chainId = injectedChainId !== null && injectedChainId !== void 0 ? injectedChainId : currentChainId;

  var _useCosmWasmClient = (0,useCosmWasmClient/* useCosmWasmClient */.h)(chainId),
      cosmWasmClient = _useCosmWasmClient.cosmWasmClient;

  var _useDenoms = (0,useDenoms/* default */.Z)(),
      getDenomById = _useDenoms.getDenomById,
      denoms = _useDenoms.denoms;

  var _useQuery = (0,useQuery/* useQuery */.a)(['calcClient', chainId], function () {
    return getClient(chainId, cosmWasmClient, getDenomById);
  }, {
    enabled: !!chainId && !!cosmWasmClient && !!denoms,
    staleTime: 1000 * 60 * 10,
    meta: {
      errorMessage: 'Error fetching calc client'
    }
  }),
      client = _useQuery.data,
      helpers = (0,objectWithoutProperties/* default */.Z)(_useQuery, _excluded);

  return _objectSpread({
    client: client
  }, helpers);
}

/***/ }),

/***/ 41799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ invalidateStrategies; },
/* harmony export */   "M": function() { return /* binding */ useStrategies; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67848);
/* harmony import */ var src_pages_queryClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98392);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6285);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98991);
/* harmony import */ var _cosmos_kit_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54056);
/* harmony import */ var _helpers_chains__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87038);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18459);
/* harmony import */ var bech32__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27715);
/* harmony import */ var _useCalcClient_getClient_clients_cosmos__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22606);
/* harmony import */ var _useDenoms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99867);
/* harmony import */ var _useWallet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5403);












var QUERY_KEY = 'get_vaults_by_address';
var invalidateStrategies = function invalidateStrategies() {
  return src_pages_queryClient__WEBPACK_IMPORTED_MODULE_1__/* .queryClient.invalidateQueries */ .E.invalidateQueries([QUERY_KEY]);
};
function useStrategies() {
  var _useWallet = (0,_useWallet__WEBPACK_IMPORTED_MODULE_8__/* .useWallet */ .O)(),
      address = _useWallet.address,
      connected = _useWallet.connected;

  var _useDenoms = (0,_useDenoms__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      getDenomById = _useDenoms.getDenomById;

  var chains = (0,rambda__WEBPACK_IMPORTED_MODULE_9__/* .values */ .V)((0,_cosmos_kit_react__WEBPACK_IMPORTED_MODULE_2__/* .useChains */ .C$)(( true ? src_constants__WEBPACK_IMPORTED_MODULE_4__/* .MAINNET_CHAINS */ .ZY : 0).map(_helpers_chains__WEBPACK_IMPORTED_MODULE_3__/* .getChainCosmosName */ .qs)));

  var _useQuery = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_10__/* .useQuery */ .a)(['strategies', address], /*#__PURE__*/(0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
    var fetchStrategies;
    return _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetchStrategies = /*#__PURE__*/function () {
              var _ref2 = (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(chain) {
                var client, calcClient, userAddress;
                return _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return chain.getCosmWasmClient();

                      case 2:
                        client = _context.sent;
                        calcClient = (0,_useCalcClient_getClient_clients_cosmos__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(chain.chain.chain_id, (0,_helpers_chains__WEBPACK_IMPORTED_MODULE_3__/* .getDCAContractAddress */ .cr)(chain.chain.chain_id), client, getDenomById);
                        userAddress = bech32__WEBPACK_IMPORTED_MODULE_5__/* .bech32.encode */ .gW.encode((0,_helpers_chains__WEBPACK_IMPORTED_MODULE_3__/* .getAddressPrefix */ .UF)(chain.chain.chain_id), bech32__WEBPACK_IMPORTED_MODULE_5__/* .bech32.decode */ .gW.decode(address).words);
                        return _context.abrupt("return", calcClient.fetchVaults(userAddress));

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function fetchStrategies(_x) {
                return _ref2.apply(this, arguments);
              };
            }();

            _context2.t0 = rambda__WEBPACK_IMPORTED_MODULE_12__/* .map */ .UI;

            _context2.t1 = function (result) {
              return result.status === 'fulfilled' ? result.value : [];
            };

            _context2.next = 5;
            return Promise.allSettled(chains.map(fetchStrategies));

          case 5:
            _context2.t2 = _context2.sent;
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t1, _context2.t2).flat());

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), {
    enabled: connected && !!address
  }),
      strategies = _useQuery.data,
      isLoading = _useQuery.isLoading;

  return {
    data: strategies,
    isLoading: isLoading
  };
}

/***/ }),

/***/ 64735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useStrategyEvents; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67848);
/* harmony import */ var _hooks_useCalcClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12229);


function useStrategyEvents(id) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _useCalcClient = (0,_hooks_useCalcClient__WEBPACK_IMPORTED_MODULE_0__/* .useCalcClient */ .V)(),
      client = _useCalcClient.client;

  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(['strategyEvents', id, client], function () {
    return client.fetchVaultEvents(id);
  }, {
    enabled: !!client && !!id && !!enabled,
    meta: {
      errorMessage: 'Error fetching strategy events'
    }
  });
}

/***/ })

}]);